<!-- 消息框 -->
<template>
  <!--
    message-pane 必须有确定高度：下面 .message 用 calc(100% - 输入框高) 算自己，
    而百分比高度只在父级高度确定时才成立。以前这个根 div 没类名、高度 auto，
    所以 .message 只能靠给滚动区写死像素高来凑，凑漏了就是工具栏压住内容。
  -->
  <div class="message-pane">
    <div v-loading="listLoading" class="message" v-if="currentUser">
      <header class="header">
        <div class="friendname">
          <img :src="currentUser.toUserHeadImg" v-if="currentUser.toUserHeadImg" />
          <img src="@/assets/du_logo.png" v-else>
          <div class="item-box">
            <p>{{currentUser.toUserRealName}} {{currentUser.toUserMobile}}</p>
            <span>{{currentUser.toUserLevelName}}</span>
          </div>

        </div>
        <div class="hzxx">
          <img src="@/assets/img1.png" @click="handleSetIsTop" />
          <el-dropdown @command="handleCommand">
            <img src="@/assets/img2.png" />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(1)">查看聊天记录</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(2)">设置备注和标签</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

      </header>
      <!--
        高度交给 flex 撑（见 style 里的 .message），不再写死 windowHeight - 322。
        那个 322 是"头部 + 输入框 + 工具栏"的手算值，少算了 .items-box 的 52px，
        于是工具栏（absolute bottom:0）常年压着滚动区最后 52px 的内容 —— 平时只是压住
        上一条消息看不出来，AI 草稿卡片一来，被压住的就是「发送/编辑后发送」按钮。
      -->
      <div ref="msgBox" class="message-wrapper" @scroll="onScrollListener">
        <div v-if="iconLoading" style="text-align: center;">
          <i class="el-icon-loading" />
        </div>
        <ul style="min-height: 101%;">
          <li v-for="(item,index) in msgList" :id="`list-${index}`" :key="index" class="message-item">
            <div class="time">
              <span v-if="item.createdTime != ''" :key="item.createdTime">{{changeTime(item.createdTime)}}</span>
            </div>
            <div class="main" :class="{ self: item.toUserId === currentUser.toUserId && item.toUserInfoId  === currentUser.toUserInfoId && item.toUserType  === currentUser.toUserType}">
              <img class="avatar" width="36" height="36" :src="item.fromHeadImg" v-if="item.toUserId === currentUser.toUserId && item.toUserInfoId  === currentUser.toUserInfoId && item.toUserType  === currentUser.toUserType">
              <template v-else>
                <img class="avatar" width="36" height="36" :src="item.fromHeadImg" v-if="item.fromHeadImg">
                <img class="avatar" width="36" height="36" src="@/assets/du_logo.png" v-else>
              </template>
              <div class="content-box">
                <!-- // messageType 文本10 图像11 语音12 商品20 商品订单21 售后订单22 服务订单23  课程24 课程闯关25 -->
                <div class="content" v-if="item.messageType === 10">
                  <div class="text" v-html="replaceFace(item.messageContent)" />
                </div>
                <div v-if="item.messageType === 11" class="img-box">
                  <img :src="item.messageContent" style="max-width:100%">
                </div>
                <!-- 产品 -->
                <div class="prod-info" v-if="item.messageType === 20">
                  <div class="order-info">
                    <img :src="item.messageContent.img" />
                    <div class="order">
                      <p class="ellipsis1">{{item.messageContent.name}}</p>
                      <p>销量{{item.messageContent.virtualSalesCount}}</p>
                      <span>¥{{item.messageContent.retailPrice}}</span>
                    </div>
                  </div>
                </div>
                <!-- 订单 -->
                <div class="prod-info" v-if="item.messageType === 21 || item.messageType === 22">
                  <div class="order-info" v-if="item.messageContent.goods">
                    <img src="http://freesaasofficedata.oss.aliyuncs.com/2222/2b0f556c5f4740ada8e13b514aeea59071.jpg" />
                    <div class="order">
                      <p class="ellipsis1">{{item.messageContent.goods.afterGoodsName}}</p>
                      <p>共{{item.messageContent.goods.goodsCount}}件商品</p>
                    </div>
                  </div>
                  <div class="ord-no">
                    <div>订单号：{{item.messageContent.orderNum}}</div>
                    <div>创建时间：{{item.messageContent.createdTime || item.messageContent.applyTime}}</div>
                    <span>{{item.messageType === 21?(item.messageContent.type === 1?'订货订单':(item.messageContent.type === 2?'积分订单':'秒杀订单')):'售后订单'}}</span>
                  </div>
                </div>
                <!-- 课程 -->
                <div class="prod-info" v-if="item.messageType === 24">
                  <div class="order-info course">
                    <img :src="item.messageContent.coverImage" />
                    <div class="order">
                      <p class="ellipsis1">{{item.messageContent.name}}</p>
                      <p v-if="item.messageContent.lecturerRealName">主讲老师：{{item.messageContent.lecturerRealName}} <span class="level" v-if="item.messageContent.lecturerLevelName">
                          【{{item.messageContent.lecturerLevelName}}】</span></p>
                      <em v-if="item.messageContent.chapterNum">共{{item.messageContent.chapterNum}}节</em>
                      <p class="eye"><i class="el-icon-view"></i>{{item.messageContent.playNum}}</p>
                    </div>
                  </div>
                </div>
                <!-- 闯关 -->
                <div class="challenge-box" v-if="item.messageType === 25">
                  <el-progress type="circle" :percentage="item.messageContent.completeRate" width="50" stroke-width="4"></el-progress>
                  <span>{{item.messageContent.name}}</span>
                  <em>{{item.messageContent.completeRate === 100?'已完成':(!item.messageContent.completeRate?'未开始':'闯关中')}}</em>
                </div>
                <!-- 预约服务 -->
                <div class="appointment" v-if="item.messageType === 23">
                  <div>你正在咨询线上预约服务订单</div>
                  <p>预约服务类型：{{item.messageContent.serviceItems}}</p>
                  <p>订单号：{{item.messageContent.orderNo}}</p>
                  <p>创建时间：{{item.messageContent.createdTime}}</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!--
        REQ-2026-574277 二期修订 §4：AI 草稿（待审核）卡片。

        它是**会话流和工具栏之间的独立一层**，不在滚动容器里 ——
        原先内联在流末尾有两个治不好的毛病：
          1. 长草稿（QWEN 兜底动辄几百字）会把整段对话顶出可视区，客服看不到客户到底问了什么；
          2. 卡片底部的操作按钮正好落在被工具栏盖住的那 52px 里，只露半截。
        现在高度由 flex 分配、卡片自己封顶，两个毛病一起消失。
        （早先那条"必须放在滚动容器里面"的注释是针对写死高度的老布局的，那个前提已经没了。）
      -->
      <ai-draft-card
        ref="aiDraftCard"
        :conversation-id="currentUser ? currentUser.id : null"
        @changed="handleAiDraftChanged"
      />
      <div class="items-box">
        <div class="item-left">
          <el-tag v-for="(item,index) in items" :key="index" effect="plain" @click="hanldeTag(item)">
            {{ item.name }}
          </el-tag>
        </div>
        <div class="item-right">
          <el-tag effect="plain" @click="handleKnowledge">知识库</el-tag>
          <el-tag effect="plain" @click="handlePhrases">常用语</el-tag>
        </div>
      </div>
      <chat-history-vue ref="chatHistoryVue" />
      <knowledge-vue ref="knowledgeVue" @created="handleSure" />
      <phrases-vue ref="phrasesVue" @created="handleSure" />
      <product-vue ref="productVue" @created="handleSure" />
      <order-vue ref="orderVue" :currentUser="currentUser" @created="handleSure" />
      <sales-vue ref="salesVue" :currentUser="currentUser" @created="handleSure" />
      <challenge-vue ref="challengeVue" @created="handleSure" :currentUser="currentUser" />
      <appointment-vue ref="appointmentVue" :currentUser="currentUser" @created="handleSure" />
      <course-vue ref="courseVue" @created="handleSure" />
      <set-remark-vue ref="setRemarkVue" />
    </div>
    <!--
      v-else：没选中会话时才是空状态。
      原来没写 v-else，会话开着它也照样渲染，在聊天区下面白占 300 多像素，
      把 .message-pane 撑得比卡片还高 —— 看不见（被输入框盖着）但会参与高度计算。
    -->
    <el-empty v-else :image-size="200"></el-empty>
  </div>
</template>

<script>
import chatHistoryVue from '../other/chatHistory.vue'
import knowledgeVue from '../other/knowledge.vue'
import phrasesVue from '../other/phrases.vue'
import productVue from '../other/product.vue'
import orderVue from '../other/order.vue'
import salesVue from '../other/sales.vue'
import challengeVue from '../other/challenge.vue'
import appointmentVue from '../other/appointment.vue'
import { imIdRawParts, imIdPrefixOf } from '@/utils/imId'
import { CONV_C2C } from '@/utils/tim-message'
import courseVue from '../other/course.vue'
import setRemarkVue from '../other/setRemark.vue'
import aiDraftCard from './aiDraftCard.vue'
// import { mapGetters, mapState, mapActions } from 'vuex'
// import { twenDialog, surgeryQaList } from '@/api/interrogation'
// import { connectWebsocket } from '@/utils/websockets'
// import { getWsUrl } from '@/utils/encrypt/method'
import { dateTime1, spaceTime } from "@/utils/dateTime.js";
import imConversationApi from '@/api/customer/imConversation'
import TimMessage from '@/utils/tim-message'
import { formatDateStr } from '@/utils/index'
import store from "@/store";
import imConversationMessageApi from '@/api/customer/imConversationMessage'
import { UploadFile } from '@/api/_user'
export default {
  components: {
    chatHistoryVue, knowledgeVue, phrasesVue, productVue, orderVue,
    salesVue, challengeVue, appointmentVue, courseVue,
    setRemarkVue, aiDraftCard
  },
  props: ['windowHeight', 'serviceInfo'],
  data() {
    return {
      msgList: [],
      currentUser: null,
      items: [{ id: 1, name: '产品' }, { id: 2, name: '订货订单' }, { id: 3, name: '秒杀订单' },
      { id: 4, name: '积分订单' }, { id: 6, name: '售后申请' }, { id: 7, name: '课程' },
      { id: 8, name: '闯关模式' }, { id: 9, name: '预约服务' }],
      listLoading: false,
      iconLoading: false,
      pageSize: 10,//聊天分页条数
      pageIndex: 1,//聊天分页索引
      Wscroll: false, // 判断是否因下拉加载改变list
      isLoadMore: false,
      isRepSub: false,
      // 客服自己登录 IM 用的账号 ID，由服务端下发（非生产环境带环境前缀）。
      // 拼收件人 ID 时拿它当参照物反推前缀 —— 前端不知道前缀的具体值。
      myImUserId: '',
      // 当前对话的拉新定时器（见 startMessagePoll）。**不再只给 H5 用**，理由见那里。
      h5PollTimer: null,
      // 收到腾讯 IM 推送后合并触发拉新用的句柄（见 onMessageReceived）
      pushPollTimer: null,
      // 消息流正在整份/分页重拉。这期间 H5 拉新必须让路，见 pollH5Messages
      msgReloading: false,
    }
  },
  created() {
    this.userId = store.getters.userId + "";
    this.tim = new TimMessage(this);
    this.getUserTimSign();
    // ⚠️ 这三个原来是匿名函数，beforeDestroy 里解不掉。$EventBus 是全局的，
    //    后台又是多标签页，反复进出「消息管理」监听就累积，一次点发送会发 N 条
    //    （BUG-2026-332444：生产客户收到 13 条同样的消息）。必须具名 + $off。
    //发送消息
    this.$EventBus.$on('brotherSendMessge', this.sendTextMessage)
    //点击客户列表
    this.$EventBus.$on('handleChatList', this.handleContactUser)
    //点击发送图片
    this.$EventBus.$on('onInputChange', this.handleInputChange)
    // 会话列表每 30 秒刷新一次，当前会话的渠道可能变了（客户中途从原生换到 H5 页，或反过来）
    this.$EventBus.$on('csActiveConversationRefreshed', this.onActiveConversationRefreshed)
    this.$EventBus.$on('csConversationEnded', this.onConversationEnded)
    document.addEventListener('visibilitychange', this.onVisibilityChangeForPoll)

  },
  mounted() {

  },
  beforeDestroy() {
    this.$EventBus.$off('brotherSendMessge', this.sendTextMessage)
    this.$EventBus.$off('handleChatList', this.handleContactUser)
    this.$EventBus.$off('onInputChange', this.handleInputChange)
    this.$EventBus.$off('csActiveConversationRefreshed', this.onActiveConversationRefreshed)
    this.$EventBus.$off('csConversationEnded', this.onConversationEnded)
    if (this.pushPollTimer) { clearTimeout(this.pushPollTimer); this.pushPollTimer = null }
    document.removeEventListener('visibilitychange', this.onVisibilityChangeForPoll)
    this.stopH5Poll()
  },
  methods: {
    onConversationListUpdated(data) {
      this.$EventBus.$emit('handleConversationListUpdated', data)
    },
    onScrollListener(event) {
      if (this.isLoadMore) return
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      console.log(scrollTop)
      if (scrollTop === 0) {
        this.pageIndex++
        this.getMessageList()
      }
    },
    //点击用户
    async handleContactUser(item) {
      if (this.currentUser && this.currentUser.id === item.id) {
        return;
      }
      this.msgList = [];
      this.currentUser = item;
      this.pageIndex = 1;
      this.getMessageList();
      this.setReadMessage();
      // 换会话：旧会话的拉新先停，新会话是 H5 才起
      this.startH5Poll();
    },
    // ===================== 第 3 步：H5 会话拉新 =====================
    //
    // 原生会话的新消息靠腾讯 IM 的事件推过来（onMessageReceived）。H5 客户不经过腾讯 IM，
    // 没有任何事件会告诉工作台"他又说话了" —— 不轮询的话，客服得切走再切回来才看得到。
    //
    // 只在「当前打开的会话是 H5」且「页面可见」时跑，5 秒一次（与 H5 客户侧的轮询间隔对齐，
    // 再快没有意义：客户那边也要 5 秒才看得到回复）。原生会话一行不动。
    //
    // 它和顶栏那个 30 秒定时器**不是重复**：那个管全局（会话列表 + 待审计数），这个只管眼前这一条对话流。
    startMessagePoll() {
      this.stopH5Poll()
      if (!this.currentUser || document.hidden) return
      this.h5PollTimer = setInterval(this.pollH5Messages, 5000)
    },
    // 兼容原来的调用名
    startH5Poll() {
      this.startMessagePoll()
    },
    stopH5Poll() {
      if (this.h5PollTimer) {
        clearInterval(this.h5PollTimer)
        this.h5PollTimer = null
      }
    },
    onVisibilityChangeForPoll() {
      if (document.hidden) {
        // 标签页挂后台就真的停掉，不是"跑着但跳过"
        this.stopH5Poll()
      } else if (this.isH5Conversation()) {
        // 切回来立即补拉一次，不等下一个 5 秒
        this.pollH5Messages()
        this.startH5Poll()
      }
    },
    onActiveConversationRefreshed(row) {
      if (!this.currentUser || !row || row.id !== this.currentUser.id) return
      if (row.sourceChannel !== this.currentUser.sourceChannel) {
        this.currentUser.sourceChannel = row.sourceChannel
        this.startH5Poll()
      }
    },
    pollH5Messages() {
      // ⚠️ 原来这里还有 `|| !this.isH5Conversation()`：只给 H5 会话拉新。
      //    但 source_channel 生产上 16022 条**全是 NULL**（只有客户真的用过 H5 对话页才会被标记，
      //    而 App 的客服入口目前仍走腾讯 IM），判断恒假 —— 这个兜底从来没有跑过。
      //    现在对所有会话都跑：原生会话平时靠腾讯 IM 推送，这一拍只是它挂掉时的兜底，
      //    按库 id 去重，不会重复显示。
      if (!this.currentUser) return
      // 消息流正在重拉（切会话 / 草稿处理后 msgList 被清空重载）时让路：
      // 那一刻 msgList 是空的，拉新会把最近 20 条当成"全是新的"追加进去，
      // 紧接着重拉的结果又 unshift 一遍 —— 整屏消息显示两次。
      if (this.msgReloading) return
      const asked = this.currentUser.id
      const { fromUserType, toUserId } = this.currentUser
      imConversationMessageApi.fetchList({
        operatorUserType: fromUserType,
        pageNo: 1,
        // 5 秒内不太可能来 20 条以上；真来了，下一拍会接着补（按 id 去重，不会丢也不会重）
        pageSize: 20,
        peerUserId: toUserId
      }).then(({ data }) => {
        // 防串台：请求回来时客服可能已经切到别的会话了；也可能这期间触发了重拉
        if (!this.currentUser || this.currentUser.id !== asked || this.msgReloading) return
        const known = new Set()
        this.msgList.forEach(m => { if (m && m.id != null) known.add(String(m.id)) })
        // ⚠️ 去重靠库里的 id。客服自己刚发的那条走 saveForOWN，接口返回值里带 id，
        //    本地追加的就是带 id 的那份，所以这里拉回来时能对上、不会重复显示。
        //
        // ⚠️⚠️ **必须再加一道「比现有最新一条还新」** —— 只判"id 不在 msgList 里"是不够的：
        //    首屏 getMessageList 每页只取 **10** 条，而这里一次取 **20** 条，
        //    第 11~20 条是**更旧**的消息，它们同样不在 msgList 里，于是被当成新消息
        //    push 到列表末尾 → 屏幕上更早的消息跑到最新消息下面。
        //    只要会话消息数 > 10，打开后第一拍（5 秒）必现。
        //    这是 2026-09-21 cd64174 把拉新放开到所有会话后的线上回归（10:36 已发生产）：
        //    在那之前这段代码只对 H5 会话跑，而 H5 会话都很短，从没暴露过。
        //    依据：im_conversation_message.id 自增，与 created_time 同向（生产数据核过）。
        const maxKnownId = this.msgList.reduce(
          (m, x) => (x && x.id != null ? Math.max(m, Number(x.id)) : m), 0)
        const fresh = ((data && data.list) || [])
          .filter(m => m && m.id != null && !known.has(String(m.id)) && Number(m.id) > maxKnownId)
          .sort((a, b) => Number(a.id) - Number(b.id))
        if (!fresh.length) return
        let hasCustomerMsg = false
        fresh.forEach(item => {
          if (item.messageType > 11 && typeof item.messageContent === 'string') {
            try { item.messageContent = JSON.parse(item.messageContent) } catch (e) { /* 老数据可能不是 JSON，原样显示 */ }
          }
          if (item.fromUserType === 20) hasCustomerMsg = true
          this.addMsgItemToView(item)
        })
        if (hasCustomerMsg) {
          // 客服正看着这条会话 = 已读。写的是 **20→40 方向**（客户发给客服的）的 is_read，
          // 用的是现成的 setReadMessage，方向由服务端按会话行的两端定，前端不参与。
          this.setReadMessage()
          // 客户又发了一条，草稿可能变了（合并 / 新增）
          if (this.$refs.aiDraftCard) this.$refs.aiDraftCard.reload()
          this.$EventBus.$emit('aiReviewChanged')
        }
      }).catch(() => {
        // 轮询失败不弹错：5 秒一次的提示会把工作台糊满，下一拍自然重试
      })
    },
    // REQ-2026-574277 §4：草稿被发送/忽略之后
    handleAiDraftChanged() {
      // 发出去的那条是服务端以客服名义发的、不经过本页的 IM SDK，
      // 所以要从库里重拉一遍消息流，它才会出现在对话里
      this.pageIndex = 1
      this.msgList = []
      this.getMessageList()
      // 顶部「待审核 N」计数在父页面，通知它刷新
      this.$EventBus.$emit('aiReviewChanged')
    },
    //设置阅读消息
    setReadMessage() {
      imConversationApi.setReadMessage({
        id: this.currentUser.id
      })
    },
    //设置是否置顶
    handleSetIsTop() {
      imConversationApi.setIsTop({
        id: this.currentUser.id,
        isTop: true
      }).then((res) => {
        if(res.code === '0' && res.data) {
          this.$message.success('置顶成功')
        }
      })
    },
    //获取消息列表
    getMessageList() {
      if (!this.currentUser) return;
      let { fromUserType, toUserId } = this.currentUser;
      this.msgReloading = true
      imConversationMessageApi.fetchList({
        operatorUserType: fromUserType,
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        peerUserId: toUserId
      }).then(({ data }) => {
        let list = data.list || [];
        let oldTime = "";
        list.reverse();
        for (let i = 0; i < list.length; i++) {
          if (oldTime && !spaceTime(list[i].createdTime, oldTime)) {
            list[i].createdTime = "";
          } else {
            oldTime = list[i].createdTime;
          }
        }
        list.reverse();
        // 按 id 去重：分页是按"第几页"翻的，翻页之间只要来过新消息（H5 拉新 / 腾讯 IM 推送 / 自己发的），
        // 页的边界就会整体后移，下一页的头几条就是上一页的尾几条，会重复显示。
        const known = new Set()
        this.msgList.forEach(m => { if (m && m.id != null) known.add(String(m.id)) })
        list.forEach(item => {
          if (item.id != null && known.has(String(item.id))) return
          if (item.messageType > 11) {
            item.messageContent = JSON.parse(item.messageContent);
          }
          this.msgList.unshift(item);
        });
        this.isLoadMore = this.pageIndex === data.pageCount ? true : false;
        if (this.pageIndex === 1) {
          this.scrollToBottom();
        }
      }).finally(() => {
        this.msgReloading = false
      });
    },
    // 拼收件人的 IM 账号 ID。
    // 会话记录里存的是业务字段（userId / 客户id / 身份类型），拼出来是裸 ID；
    // 非生产环境对端账号带环境前缀，裸 ID 在腾讯那边根本不存在，消息发不到人。
    // 前端不知道前缀值，用客服自己的账号 ID 反推。生产前缀为空，结果与原来一致。
    buildToImId(toUserId, toUserInfoId, toUserType) {
      return `${imIdPrefixOf(this.myImUserId)}${toUserId}_${toUserInfoId}_${toUserType}`
    },
    // 点击发送按钮发送信息
    sendTextMessage(content) {
      // 没有选中会话（含刚点完「结束会话」）时直接拦下：
      // 下面是对 currentUser 的解构，为 null 会抛 TypeError，客服看到的是一片空白没有任何提示。
      if (!this.currentUser) {
        this.$message.warning('请先在左侧选择一个会话')
        return
      }
      let { toUserId, toUserInfoId, toUserType } = this.currentUser;
      if (!content && !toUserId && !toUserInfoId) return;
      let to_userId = this.buildToImId(toUserId, toUserInfoId, toUserType)
      if (this.isRepSub) return
      this.isRepSub = true
      if (this.isH5Conversation()) {
        // H5 客户：直接落库，不经过腾讯 IM（原因见 isH5Conversation 的注释）
        this.saveMsgToSerive(content, 10, this.currentUser);
        return
      }
      this.tim.sendTextMessage(to_userId, content, CONV_C2C).then(res => {
        this.saveMsgToSerive(content, 10, this.currentUser);
      }).catch(err => {
        // 发失败也要复位，否则 isRepSub 一直是 true，输入框以后再也发不出去
        this.isRepSub = false
        this.$message.error('消息发送失败：' + (err && err.message ? err.message : err))
      });
    },
    // REQ-2026-574277 二期修订 §11：这个客户此刻是不是在 H5 对话页里。
    //
    // 现状的发送顺序是「先发腾讯 IM，成功了才落库」。H5 客户不能这么走：
    //   · H5 化之后的新客户可能从来没注册过腾讯 IM 账号 → TIM 发送失败 → 后面的落库不执行
    //     → 客户在 H5 里永远等不到回复，而客服这边只看到一句"消息发送失败"
    //   · H5 对话页是轮询库里的消息，落库本身就是"送达"
    // 所以 H5 会话跳过 TIM，直接调落库接口。其余会话一行不动。
    //
    // sourceChannel 是服务端算好的"生效值"（全局通道开关不是 H5 时一律给 IM），
    // 前端不要自己再去读开关 —— 判定只能有一份，和 app-server 的 AI 回复路由保持一致。
    isH5Conversation() {
      return !!this.currentUser && this.currentUser.sourceChannel === 'H5'
    },
    //保存消息内容
    saveMsgToSerive(message, msgType, to) {
      imConversationMessageApi.create({
        isRead: 0,
        messageContent: message,
        messageType: msgType,
        toUserId: to.toUserId,
        toUserInfoId: to.toUserInfoId,
        toUserType: to.toUserType,
      }).then((res) => {
        this.isRepSub = false
        let data = res.data;
        let createdTime = formatDateStr(new Date());
        let len = this.msgList.length;
        if (len > 0 && !spaceTime(this.msgList[len - 1].createdTime, createdTime)) {
          createdTime = "";
        }
        if (msgType > 11) {
          data.messageContent = JSON.parse(data.messageContent)
        }
        data.fromHeadImg = this.serviceInfo.headImg
        data.createdTime = createdTime;
        this.addMsgItemToView(data)
        // 自己发完也要让会话列表动起来（最后一条消息、排序），原来只更新了消息流
        this.$EventBus.$emit('handleConversationListUpdated', null)
      }).catch(res => {
        this.isRepSub = false
      });
    },
    //点击发送图片
    handleInputChange() {
      if (!this.currentUser) {
        this.$message.warning('请先在左侧选择一个会话')
        return
      }
      let { toUserId, toUserInfoId, toUserType } = this.currentUser;
      if (!toUserId && !toUserInfoId) return;
      let to_userId = this.buildToImId(toUserId, toUserInfoId, toUserType)
      if (this.isH5Conversation()) {
        // H5 客户：图片不能借腾讯 IM 的上传（那是 TIM 发消息的副产物），改走后台通用的 COS 上传，拿到地址再落库
        const picker = document.getElementById('imagePicker')
        const file = picker && picker.files && picker.files[0]
        if (!file) return
        const formData = new FormData()
        formData.append('file', file)
        UploadFile(formData).then(res => {
          if (!res || !res.data) {
            this.$message.error('图片上传失败，请重试')
            return
          }
          this.saveMsgToSerive(res.data, 11, this.currentUser);
        }).catch(() => {
          this.$message.error('图片上传失败，请重试')
        }).finally(() => {
          // 同一张图连发两次时 change 事件不触发，清掉选择
          picker.value = ''
        })
        return
      }
      this.tim.sendImageMessage(to_userId, "imagePicker", CONV_C2C).then(({ data }) => {
        let { imageInfoArray } = data.message.payload;
        let imageUrl = imageInfoArray[0].imageUrl;
        this.saveMsgToSerive(imageUrl, 11, this.currentUser);
      });
    },
    //发送自定义消息
    handleSure(data, type) {
      // messageType 文本10 图像（单图11 语音12 商品20 商品订单21 售后订单22 服务订单23  课程24 课程闯关25
      //type 1 产品 15 知识库 16 常用语
      if (type === 1) this.sendCustom(data, 20)
      else if (type === 6) this.sendCustom(data, 22)
      else if (type === 7) this.sendCustom(data, 24)
      else if (type === 8) this.sendCustom(data, 25)
      else if (type === 9) this.sendCustom(data, 23)
      else if (type === 15) this.sendTextMessage(data.content)
      else if (type === 16) this.sendTextMessage(data.title)
      else this.sendCustom(data, 21)
      // items: [{ id: 1, name: '产品' }, { id: 2, name: '订货订单' }, { id: 3, name: '秒杀订单' },
      //       { id: 4, name: '积分订单' }, { id: 6, name: '售后申请' }, { id: 7, name: '课程' },
      //       { id: 8, name: '闯关模式' }, { id: 9, name: '预约服务' }],
    },
    sendCustom(content, type) {
      if (!this.currentUser) {
        this.$message.warning('请先在左侧选择一个会话')
        return
      }
      let { toUserId, toUserInfoId, toUserType } = this.currentUser;
      if (!content && !toUserId && !toUserInfoId) return;
      let to_userId = this.buildToImId(toUserId, toUserInfoId, toUserType)
      if (this.isH5Conversation()) {
        // H5 对话页目前只画得出文字和图片，卡片在客户那边只会显示成"[商品]"这样的占位字。
        // 与其发一张客户看不到的卡片、还让客服以为发出去了，不如明说。
        this.$message.warning('该客户正在使用新版客服页面，暂不支持发送商品/订单/课程卡片，请改用文字说明')
        return
      }
      this.tim.sendCustomMessage(to_userId, content, this.calcBusinessID(type), "", CONV_C2C).then(res => {
        this.saveMsgToSerive(JSON.stringify(content), type, this.currentUser);
      });
    },
    calcBusinessID(type) {
      let businessID = ''
      switch (type) {
        case 20:
          businessID = 'coustomer_product'
          break
        case 21:
          businessID = 'coustomer_order'
          break
        case 22:
          businessID = 'coustomer_sales_order'
          break
        case 23:
          businessID = 'coustomer_appointment'
          break
        case 24:
          businessID = 'coustomer_course'
          break
        case 25:
          businessID = 'coustomer_challenge'
          break
      }
      return businessID
    },
    //给视图添加消息类容
    addMsgItemToView(data) {
      let len = this.msgList.length;
      // ⚠️ 这里原来写的是 `new Date()`（"现在"），于是时间分隔条显示与否取决于
      //    「上一条的时间 vs 当前时刻」，与这条消息自己的时间无关 ——
      //    拉新补进来的历史消息会因此带上一条位置莫名其妙的分隔条。
      //    要比的是**这条消息自己的时间**。
      let createdTime = data.createdTime || new Date();
      if (len > 0 && !spaceTime(this.msgList[len - 1].createdTime, createdTime)) {
        data.createdTime = "";
      }
      this.msgList = this.msgList || []; // 确保 msgList 是数组
      this.msgList.push(data);
      this.scrollToBottom();
    },
    //滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        let el = this.$refs.msgBox;
        if (!el) return;
        setTimeout(() => {
          el.scrollTop = el.scrollHeight;
        }, 100);
        // let height = this.msgList.length * 300;
        // setTimeout(() => {
        //   el.scrollTo(0, height, "smooth");
        // }, 100)
      })
    },

    getUserTimSign() {
      imConversationApi.getUserSign().then(({ data }) => {
        this.myImUserId = data.userId + ""
        // ⚠️ 这里原来没有 .catch：腾讯 IM 登录失败时 Promise 静默 reject，
        //    监听一个都没绑上，客服此后**永远收不到实时消息**，而界面毫无异样、
        //    手动刷新（读库）又一切正常 —— BUG-2026-979880 报的就是这个表现。
        //    现在失败要让客服看见；下面的定时拉新是兜底，登不上也不至于瞎。
        this.tim.loginTim(this.myImUserId, data.userSig).catch(err => {
          console.error('IM 登录失败', err)
          this.$message.warning('实时消息未连接，新消息会延迟几秒显示；若长时间收不到请刷新页面')
        })
        this.$EventBus.$emit('getUserId', data.userId)
      })
    },

    handleKnowledge() {
      this.$refs.knowledgeVue.handleShow()
    },
    handlePhrases() {
      this.$refs.phrasesVue.handleShow()
    },
    hanldeTag(item) {
      if (item.id === 1) return this.$refs.productVue.handleShow()
      if (item.id === 2 || item.id === 3 || item.id === 4) return this.$refs.orderVue.handleShow(item.id)
      if (item.id === 6) return this.$refs.salesVue.handleShow()
      if (item.id === 7) return this.$refs.courseVue.handleShow()
      if (item.id === 8) return this.$refs.challengeVue.handleShow()
      if (item.id === 9) return this.$refs.appointmentVue.handleShow()
    },
    beforeHandleCommand(command, row) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (command.command === 1) {
        this.$nextTick(() => {
          this.$refs.chatHistoryVue.handleShow(this.currentUser)
        })
      } else if (command.command === 2) {
        this.$refs.setRemarkVue.handleShow(this.currentUser)
      }
    },
    changeTime(date) {
      return dateTime1(date);
    },
    // ...mapActions(['get_info']),
    // //  在发送信息之后，将输入的内容中属于表情的部分替换成emoji图片标签
    // //  再经过v-html 渲染成真正的图片
    replaceFace(con) {
      if (con.includes('/:')) {
        var emojis = this.emojis
        for (var i = 0; i < emojis.length; i++) {
          con = con.replace(
            emojis[i].reg,
            '<img src="static/emoji/' +
            emojis[i].file +
            '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />'
          )
        }
        return con
      }
      return con
    },
    //接收消息
    onMessageReceived(data) {
      // ⚠️ 这里**不再直接往界面塞消息**。原来是自己拼一条 {createdTime, messageType, messageContent}
      //    追加进 msgList —— 那条没有库 id，而拉新是按库 id 去重的，两条路一起跑必然重复显示。
      //    现在统一成：**库是唯一数据源，腾讯 IM 推送只负责"立刻去拉一次"**。
      //    好处是推送在与不在，显示逻辑完全一样；代价是多一次请求、慢几百毫秒。
      this.schedulePollByPush()
      if (!this.currentUser) return;
      // 解析发送者ID。不能直接 split('_')：非生产环境 ID 前面有一段环境前缀
      // （形如 t_132300_1_40），取到的 fromUserId 会是前缀，+fromUserId 变 NaN，
      // 下面的比对永远不成立 —— 表现成「客服端一条消息都收不到」。
      const [fromUserId, fromUserInfoId, fromUserType] = imIdRawParts(data.from);
      if (+fromUserId === this.currentUser.toUserId &&
        +fromUserInfoId === this.currentUser.toUserInfoId) {
        let message = "", messageType = 10;
        if (data.type === "TIMTextElem") {
          messageType = 10;
          message = data.payload.text;
        } else if (data.type === "TIMImageElem") {
          messageType = 11;
          let { imageInfoArray } = data.payload;
          message = imageInfoArray[0].imageUrl;
        } else if (data.type === 'TIMSoundElem') {
          //过滤语音消息
          return;
        } else if (data.type === 'TIMCustomElem') {
          message = data.payload.data;
          messageType = message.messageType
        }
        // 内容已解析但不再直接上屏，见方法开头的注释；保留解析是为了将来要做"新消息提示音/角标"时有现成的内容
        void message; void messageType;
      }
    },
    /**
     * 收到腾讯 IM 推送后，合并 300ms 内的连续推送，触发一次当前对话的拉新。
     * 一串消息同时到达时只打一次请求。
     */
    /**
     * 会话被归档（点了「结束会话」）：当前对话不能再留在界面上 ——
     * 服务端对已归档会话会拒绝继续回复，界面还开着只会让客服撞一句看不懂的报错。
     */
    onConversationEnded() {
      this.stopH5Poll()
      this.currentUser = null
      this.msgList = []
      this.$EventBus.$emit('handleConversationListUpdated', null)
    },
    /** IM 断线重连成功：期间掉的消息补拉一次，同时刷新会话列表 */
    onImReconnected() {
      this.pollH5Messages()
      this.$EventBus.$emit('handleConversationListUpdated', null)
    },
    schedulePollByPush() {
      if (this.pushPollTimer) return
      this.pushPollTimer = setTimeout(() => {
        this.pushPollTimer = null
        this.pollH5Messages()
      }, 300)
    },
  },
}
</script>

<style lang="scss" scoped>
/* 输入框 text.vue 是 absolute + height:200px 贴在 .friendinfo 底部的，
   聊天区能用的就是剩下的部分。这个 200 是和 text.vue 对齐的唯一耦合点，
   改那边的高度要回来改这里。 */
$input-box-height: 200px;

.message-pane {
  height: 100%;
}

.message {
  // width: 100%;
  // height: 75%;
  position: relative;
  /* 头部 / 会话流 / 草稿卡片 / 工具栏 四段竖排，中间那段吃掉剩余空间。
     用 flex 分配而不是各自写死像素，才不会出现"加了一段就盖住另一段"。 */
  display: flex;
  flex-direction: column;
  height: calc(100% - #{$input-box-height});

  > .header,
  > .items-box {
    flex: none;
  }

  > .message-wrapper {
    flex: 1 1 auto;
    /* flex 子项默认 min-height:auto，内容多了会把自己顶大而不是滚动 */
    min-height: 0;
    height: auto;
  }

  /* 子组件根节点，父组件的 scoped 样式能命中 */
  > .ai-draft-wrap {
    flex: none;
    /* 封顶：草稿再长也不能把对话挤没。超出的部分在卡片内部滚。 */
    max-height: 45%;
    overflow-y: auto;
    border-top: 1px solid #e7e7e7;
  }

  .header {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    // padding-bottom: 13px;
    position: relative;
    padding: 20px 20px 13px;
    border-bottom: 1px solid rgba(197, 197, 197, 0.8);
    // &::before {
    //   content: '';
    //   position: absolute;
    //   left: -20px;
    //   right: -20px;
    //   bottom: 0;
    //   height: 1px;
    //   background: rgba(197, 197, 197, 0.8);
    // }
    .friendname {
      display: flex;

      img {
        width: 46px;
        height: 46px;
        border-radius: 50%;
      }
      .item-box {
        padding-left: 10px;
        p {
          font-size: 14px;
          margin: 0;
          padding-bottom: 9px;
        }
        span {
          font-size: 14px;
          color: #1596cd;
          position: relative;
        }
      }
    }
    .hzxx {
      position: relative;
      top: 5px;
      img {
        width: 41px;
        height: 35px;
        cursor: pointer;
      }
    }
  }

  .message-wrapper {
    // min-height: 390px
    // max-height: 390px
    // 高度不在这里定，由上面的 flex 规则给（同权重、后写的赢，留着 height:90% 会把它盖掉）
    padding: 10px 15px;
    box-sizing: border-box;
    overflow-y: auto;
    border-bottom: 1px solid #e7e7e7;
    padding-top: 20px; // 添加顶部内边距，避免被header遮挡
    ul {
      padding-left: 0;
      list-style-type: none;
      padding-bottom: 40px;
      margin-top: 0; // 确保ul没有默认的上边距
    }
    .message {
      margin-bottom: 15px;
    }

    .time {
      width: 100%;
      font-size: 12px;
      margin: 10px auto;
      text-align: center;

      span {
        display: inline-block;
        padding: 10px 28px;
        color: #323232;
        border: 1px solid #c5c5c5;
        border-radius: 30px;
        font-size: 15px;
      }
    }

    .main {
      .avatar {
        width: 36px;
        height: 36px;
        float: left;
        margin-left: 15px;
        border-radius: 3px;
        object-fit: cover;
      }
      .content-box {
        /* 330px 是给一两行短消息定的。AI 客服接进来之后，一条回复动辄几百字，
           挤在 330 宽里会拉成又窄又长的一条。放宽上限、同时仍然封顶，
           免得一条长消息横贯整个面板反而更难读。 */
        max-width: min(72%, 560px);
        display: inline-block;
        .content {
          display: inline-block;
          margin-left: 10px;
          position: relative;
          padding: 6px 10px;
          max-width: 100%;
          min-height: 36px;
          line-height: 24px;
          box-sizing: border-box;
          font-size: 14px;
          text-align: left;
          word-break: break-all;
          /*
            换行必须留在正文那一层（.text 里是 v-html 出来的消息原文）。
            原来没写 white-space，走默认的 normal，连续换行会被塌成一个空格 ——
            短消息看不出来，AI 那种分条目的回复会糊成没有段落的一大坨。
            ⚠️ 不能写在 .content 上：标签之间的模板缩进也会跟着变成可见空行。
          */
          > .text {
            white-space: pre-wrap;
          }
          background-color: #1596cd;
          color: #fff;
          border-radius: 4px;
          &:before {
            content: ' ';
            position: absolute;
            top: 12px;
            right: 100%;
            border: 6px solid transparent;
            border-right-color: #1596cd;
          }
        }
        .img-box {
          margin-left: 10px;
          img {
            object-fit: cover;
          }
        }
        .prod-info {
          border: 1px solid #d9d9d9;
          padding: 12px;
          width: 300px;
          box-sizing: border-box;
          border-radius: 6px;
          margin-left: 10px;
          .order-info {
            display: flex;

            img {
              width: 88px;
              height: 88px;
              object-fit: cover;
            }
            &.course {
              img {
                width: 98px;
                height: 124px;
                border-radius: 6px;
                object-fit: cover;
              }
            }
            .order {
              font-size: 14px;
              padding-left: 10px;
              width: calc(100% - 98px);
              position: relative;
              p {
                margin: 0;
                color: #6c6c6c;
                &:nth-child(2) {
                  font-size: 13px;
                  padding: 10px 0;
                }
              }
              span {
                color: #e73f3f;
                font-size: 13px;
                &.level {
                  color: #f3b71d;
                }
              }
              em {
                font-size: 12px;
                color: #4680e3;
                padding: 6px;
                border-radius: 4px;
                background: #dae6f9;
                border: 1px solid #4680e3;
                font-style: normal;
              }
              .eye {
                font-size: 14px;
                color: #999;
                position: absolute;
                bottom: 5px;
                left: 10px;
                i {
                  margin-right: 4px;
                }
              }
            }
          }
          .ord-no {
            padding-bottom: 10px;
            div {
              font-size: 14px;
              color: #6c6c6c;
              padding-top: 10px;
            }
            span {
              font-size: 13px;
              color: #1596cd;
              float: right;
            }
          }
        }
        .challenge-box {
          border: 1px solid #d9d9d9;
          padding: 12px;
          width: 300px;
          box-sizing: border-box;
          border-radius: 6px;
          margin-left: 10px;
          display: flex;
          align-items: center;

          position: relative;
          span {
            font-size: 16px;
            color: #000f29;
            padding-left: 10px;
          }
          em {
            font-style: normal;
            font-size: 14px;
            color: #000f29;
            position: absolute;
            right: 12px;
          }
        }
        .appointment {
          border: 1px solid #d9d9d9;
          padding: 12px;
          width: 300px;
          box-sizing: border-box;
          border-radius: 6px;
          margin-left: 10px;
          div {
            font-size: 16px;
            color: #000f29;
          }
          p {
            font-size: 14px;
            color: #666666;
            margin: 0;
            padding-top: 10px;
          }
        }
      }
    }

    .self {
      text-align: right;

      .avatar {
        float: right;
        margin: 0 10px;
      }
      .content-box {
        .content {
          background-color: #b2e281;

          &:before {
            right: -12px;
            vertical-align: middle;
            border-right-color: transparent;
            border-left-color: #b2e281;
          }
        }
        .prod-info {
          .order-info {
            .order {
              text-align: left;
            }
          }
          .ord-no {
            div {
              text-align: left;
            }
          }
        }
        .appointment {
          text-align: left;
        }
      }
    }
  }
  .items-box {
    background: #fff;
    /* 原来是 absolute + bottom:0 浮在滚动区上面，等于永久遮住最后 52px。
       现在它是 flex 里的一段，自己占位，不再盖住任何人。 */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    z-index: 12;
    .item-left {
      .el-tag {
        margin-right: 10px;
      }
    }
  }
}
.el-tag {
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 8px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>